import React, { useRef, useState } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { CameraAlt, UploadFile, Close } from "@mui/icons-material";

const CameraUpload = ({ label, onFileSelect, accept = "image/*", maxSizeMB = 16 }) => {
  const fileRef = useRef();
  const cameraRef = useRef();
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleFile = (file) => {
    if (!file) return;
    if (file.size > maxSizeMB * 1024 * 1024) {
      alert(`File too large. Max ${maxSizeMB}MB.`);
      return;
    }
    setFileName(file.name);
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
    onFileSelect(file);
  };

  const clear = () => {
    setPreview(null);
    setFileName("");
    onFileSelect(null);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>{label}</Typography>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
        <Button size="small" variant="outlined" startIcon={<UploadFile />} onClick={() => fileRef.current.click()}>
          Upload
        </Button>
        <Button size="small" variant="outlined" startIcon={<CameraAlt />} onClick={() => cameraRef.current.click()}>
          Camera
        </Button>
        <input ref={fileRef} type="file" accept={accept} hidden onChange={(e) => handleFile(e.target.files[0])} />
        <input ref={cameraRef} type="file" accept="image/*" capture="environment" hidden onChange={(e) => handleFile(e.target.files[0])} />
      </Box>
      {fileName && (
        <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 1 }}>
          {preview && <img src={preview} alt="preview" style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 8 }} />}
          <Typography variant="caption" sx={{ flex: 1 }}>{fileName}</Typography>
          <IconButton size="small" onClick={clear}><Close fontSize="small" /></IconButton>
        </Box>
      )}
    </Box>
  );
};

export default CameraUpload;
